import React from "react";
import CardImg from "./../Assets/Menu/MenuCArd2.png";
import Footer from "../Components/Footer/Footer";
import ProductCard from "../Components/ProductCard/ProductCard";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function ShreddedChicken() {
  useMetaTracking("ViewContent", {
    content_name: "Shredded Chicken",
    content_category: "Regular Menu",
    content_ids: ["shredded_chicken"],
    content_type: "bánh mì",
    value: 8.0,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Shredded Chicken | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Features juicy, tender, shredded chicken, delicately seasoned and tucked inside a golden, crispy baguette."
        />
        <meta property="og:title" content="Shredded Chicken | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="Features juicy, tender, shredded chicken, delicately seasoned and tucked inside a golden, crispy baguette."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <ProductCard
          cardImg={CardImg}
          titleHead="Shredded Chicken"
          titleSubHead="$8.00 each"
          detailBodyBr="Features juicy, tender, shredded chicken, delicately seasoned and tucked inside a golden, crispy baguette."
          detailBody3="Contains: wheat, soy, egg"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default ShreddedChicken;